<template>
    <div class="backpage" @click="goBack">
        <!-- <el-icon>
            <Back />
        </el-icon> -->
        返回上一步
    </div>
    <div class="installt">
        <div class="intext">角色权限管理</div>
        <div class="installts">
            <div class="addpoper2" @click="permIdListadd">保存角色</div>
        </div>
    </div>
    <div class="juename">
        <div class="nametop">角色权限编辑</div>
        <div class="nameinp">
            <input type="text" placeholder="请填写权限名称" v-model="pername">
        </div>
    </div>
    <div class="addright">
        <div class="addtop">
            选择权限
        </div>
        <div class="gong">
            <div class="guanli" v-for="(item, index) in permNodeLists" :key="item.permId">
                <div class="zong">
                    <div>
                        {{ item.permName }}
                    </div>
                    <div>
                        <el-switch v-model="item.choose" @change="ischoose(item.choose, index)" />
                    </div>
                </div>
                <div class="zhongs" v-for="(item2, index) in item.permNodeList" :key="item2.permId">
                    <div>
                        {{ item2.permName }}
                    </div>
                    <div>
                        <el-switch v-model="item2.choose" @change="qunchoose(item2.permId, item2.choose)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import store from '@/api/store';
import { computed, onMounted, ref, watch } from 'vue';
import { ElMessage, ElLoading } from 'element-plus'
import { useRoute, useRouter } from 'vue-router';
let permNodeLists = ref([])
let permIdList = ref([])
let pername = ref('')
const route = useRoute()
const router = useRouter()
const { roleId, roleName } = route.query
onMounted(() => {
    NodeLists()
    
    console.log(roleId, roleName)
    if (roleId) {
        pername.value = roleName
    }
})
watch(
    permNodeLists, () => {
        qunxuan()
    }, {
    deep: true
})
const xiugai = async () => {
    if (roleId) {
        const res = await store.getRoleDetails(roleId)
        let apermIdList = res.data.permIdList
        console.log('getRoleDetails', res.data.permIdList)
        console.log('permNodeLists.value', permNodeLists.value)
        for (let a = 0; a < permNodeLists.value.length; a++) {
            for (let c = 0; c < permNodeLists.value[a].permNodeList.length; c++) {
                for (let b = 0; b < apermIdList.length; b++) {
                   if(apermIdList[b] == permNodeLists.value[a].permNodeList[c].permId){
                    permNodeLists.value[a].permNodeList[c].choose = true
                   }
                }

            }


        }
        // permNodeLists.value
    } else {
        // return
        console.log('为新增加')
    }
}
const permIdListadd = async () => {
    let permName = []
    for (let a = 0; a < permNodeLists.value.length; a++) {
        let permIdPushed = false; // 记录是否已经执行过 permId 的 push 操作
        for (let b = 0; b < permNodeLists.value[a].permNodeList.length; b++) {
            if (permNodeLists.value[a].permNodeList[b].choose === true) {
                if (!permIdPushed) {
                    permIdList.value.push(permNodeLists.value[a].permId);
                    permIdPushed = true; // 设置为已经执行过
                }
                permIdList.value.push(permNodeLists.value[a].permNodeList[b].permId);
                permName.push(permNodeLists.value[a].permNodeList[b].permName)
            }
        }
    }
    let permNamelist = permName.join(',');
    if (pername.value.length < 1) {
        ElMessage({
            message: '请填写权限名称！',
            type: 'warning',
        })
    } else if (permIdList.value.length < 1) {
        ElMessage({
            message: '请选择权限！',
            type: 'warning',
        })
    } else {

        if (roleId) {
            let data
            if(roleName == pername.value){
                data = {
                "permIdList": permIdList.value,
                "roleDesc": permNamelist,
                "roleId": roleId,
              
                "roleSort": 1
            }
            }else{
                data = {
                "permIdList": permIdList.value,
                "roleDesc": permNamelist,
                "roleId": roleId,
                "roleName": pername.value,
                "roleSort": 1
            }
            }
            console.log(permIdList.value);
            const res = await store.alterRole(data)
            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            if (res.success) {
                setTimeout(() => {
                    loading.close()
                    ElMessage({
                        message: '修改角色成功.',
                        type: 'success',
                        duration: '800',
                        onClose: () => {
                            router.go(-1)
                        }
                    })
                }, 1000)

            } else {
                setTimeout(() => {
                    loading.close()
                    ElMessage.error(res.message)
                    location.reload()
                }, 1000)
            }
            console.log(res)
        } else {
            let data = {
                "permIdList": permIdList.value,
                "roleName": pername.value,
                "roleDesc": permNamelist,
                "roleSort": 1
            }
            console.log(permIdList.value);
            const res = await store.changeRole(data, 1)
            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            if (res.success) {
                setTimeout(() => {
                    loading.close()
                    ElMessage({
                        message: '创建角色成功.',
                        type: 'success',
                        duration: '800',
                        onClose: () => {
                            location.reload()
                        }
                    })
                }, 1000)

            } else {
                setTimeout(() => {
                    loading.close()
                    ElMessage.error(res.message)
                    location.reload()
                }, 1000)
            }
            console.log(res)
        }


    }

}
const qunxuan = () => {
    for (let a = 0; a < permNodeLists.value.length; a++) {
        let allTrue = true;
        for (let b = 0; b < permNodeLists.value[a].permNodeList.length; b++) {
            if (permNodeLists.value[a].permNodeList[b].choose === false) {
                allTrue = false;
                break;
            }
        }
        permNodeLists.value[a].choose = allTrue;
    }
}
const ischoose = (choose, index) => {
    // console.log(permNodeLists.value[a].permNodeList)
    for (let b = 0; b < permNodeLists.value[index].permNodeList.length; b++) {
        permNodeLists.value[index].permNodeList[b].choose = choose
    }
}
const qunchoose = (permId, choose) => {
    console.log(choose, permId)
}
const NodeLists = async () => {
    try {
        const res = await store.treePerm()
        let permNodeList = res.data.permNodeList
        for (let a = 0; a < permNodeList.length; a++) {
            permNodeList[a].choose = false
            for (let b = 0; b < permNodeList[a].permNodeList.length; b++) {
                permNodeList[a].permNodeList[b].choose = false
            }
        }
        permNodeLists.value = permNodeList
        console.log(permNodeLists.value)
        xiugai()
    } catch (error) {
        console.log(err)
    }
}
const goBack = () => {
    window.history.back();
}
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
}

.installt {
    width: 100%;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .installts {
        display: flex;

        .addpoper2 {
            width: 120px;
            height: 52px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;
            text-align: center;
            line-height: 52px;
            box-sizing: border-box;
            margin-right: 15px;

        }
    }

}

.juename {
    width: 93%;
    height: 146px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 35px;
    padding: 18px 0 0 30px;
    box-sizing: border-box;

    .nametop {
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
    }

    .nameinp {
        width: 90%;
        height: 52px;
        background: #FAFAFA;
        margin-top: 21px;
        padding-left: 15px;
        border-radius: 8px;


        input {
            font-size: 16px;
            color: #111827;
            outline: none;
            background: transparent;
            border: none;
            outline: medium;
            width: 100%;
            height: 50px;
        }
    }
}

.addright {
    width: 93%;
    height: calc(100% - 22px - 146px - 35px - 62px);
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 22px;
    float: left;
    padding: 32px 0 0 34px;
    box-sizing: border-box;

    .addtop {
        font-size: 18px;

        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
    }

    .gong {
        margin-top: 11px;
        width: 96%;
        height: 90%;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 8px;
            background-color: rgba(216, 216, 216, 0.2);
        }

        &::-webkit-scrollbar-thumb {
            background: #ccc; // 滑块颜色
        }

        .guanli {

            box-sizing: border-box;
            background-color: rgba(216, 216, 216, 0.2);

            .zong {
                height: 43px;
                display: flex;
                padding: 0 23px 0 17px;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                font-weight: 400;
                color: #111827;
            }

            .zhongs {
                height: 43px;
                display: flex;
                padding: 0 23px 0 33px;
                align-items: center;
                justify-content: space-between;
                background-color: #fff;
                color: rgba(0, 0, 0, 0.5);
                font-size: 16px;
                font-weight: 400;

            }

        }
    }
}
</style>